import { Collapse } from 'antd';
import styled from 'styled-components';

export default styled(Collapse)`
	// Add your styles here
`;

/*
 * The `PanelWrapper` that used to live here was dead — nothing imported it, and
 * `molecules/SearchBarModal/SearchBarModal.styles.js` defines its own identical copy, which is the
 * one that actually ships. It was deleted rather than kept, because the antd 6 fix
 * (`.ant-collapse-content-box` → `.ant-collapse-body`) would otherwise exist in two places: once
 * where a reader finds it, and once where it does nothing.
 */
